export { DEVLOGS } from "./devlogs";
export { EXPERIENCES } from "./experiences";
export { PROJECTS } from "./projects";
export { SKILLS } from "./skills";
export { TECH } from "./tech";

